'use client';

import { usePathname } from '@/navigation';
import { useEffect } from 'react';
import { useModals } from './ModalContext';
import { useIsLogined } from './LoginContext';
import { BeforeDeletingAccountModal } from '@/modals/BeforeDeletingAccountModal';

const MODAL_KEY = 'before-deleting-account';

export const UserDeletionContextProvider = ({ children }) => {
  const pathname = usePathname();
  const { open } = useModals();
  const isLogined = useIsLogined();

  useEffect(() => {
    const read = () => {
      const url = new URL(window.location.href);
      const shouldOpen = url.searchParams.get('userDeletion') === 'true' && isLogined;

      if (shouldOpen) {
        open(
          MODAL_KEY,
          <BeforeDeletingAccountModal
            onOk={() => {
              const cleanUrl = new URL(window.location.href);
              cleanUrl.searchParams.delete('userDeletion');
              window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
            }}
          />,
          true,
          'md:h-unset h-unset absolute md:static my-0 top-0 bottom-0 md:top-unset md:my-[30px]',
        );
      }
    };

    // initial
    read();

    // react to back/forward
    const onPopState = () => read();
    window.addEventListener('popstate', onPopState);

    return () => {
      window.removeEventListener('popstate', onPopState);
    };
    // re-run on pathname change (client navs) and once the user becomes known
  }, [pathname, open, isLogined]);

  return <>{children}</>;
};
